<div style="page-break-inside: avoid;" *ngIf="bankFi?.length || unsecured?.length || otherLoan?.length" class="mt-4" [ngClass]="{'container': !isSinglePageReturn, 'return-view-background-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
    <div class="row mb-4">
        <div class="col-12 text-center">
            <strong>PARTICULARS OF LIABILITIES</strong><br/>
            <i>[Attachment for serial no 8(k) of IT-10B (2023)]</i>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6"><strong>Taxpayer Name:</strong> {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-6 text-right">
           <strong>Assessment Year:</strong> {{returnData?.submissionInfo?.assessmentYear}}
        </div>
    </div>
    <div class="row mt-3 mb-5">
        <div class="col-sm-12">
            <strong>TIN</strong>&ensp;&ensp;
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div *ngIf="bankFi?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Bank & other FI
        </div>
        <div class="col-12">
            <table class="table table-bordered">                
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Name of Bank/FI</td> 
                        <td class="text-center">Account No.</td> 
                        <td class="text-center">Purpose</td> 
                        <td class="text-center">Outstanding amount</td>                  
                    </tr> 
                    <tr *ngFor="let item of bankFi; let i = index">
                        <td class="text-center">{{i+1}}</td> 
                        <td class="text-start">{{item?.name}}</td> 
                        <td class="text-start pr-3">{{item?.relatedIN}}</td> 
                        <td class="text-start pr-3">{{item?.description}}</td> 
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>            
                    </tr>                                
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="unsecured?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Unsecured Loan
        </div>
        <div class="col-12">
            <table class="table table-bordered">                
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Name of Lender</td> 
                        <td class="text-center">TIN of Lender</td> 
                        <td class="text-center">Purpose</td> 
                        <td class="text-center">Outstanding amount</td>                        
                    </tr> 
                    <tr *ngFor="let item of unsecured; let i = index">
                        <td class="text-center">{{i+1}}</td> 
                        <td class="text-start">{{item?.name}}</td> 
                        <td class="text-start pr-3">{{item?.relatedIN}}</td> 
                        <td class="text-start pr-3">{{item?.description}}</td> 
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>          
                    </tr>                                   
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="otherLoan?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Other Loan
        </div>
        <div class="col-12">
            <table class="table table-bordered">                
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Particulars of Lender</td> 
                        <td class="text-center">Type of Loan</td> 
                        <td class="text-center">Other Details</td> 
                        <td class="text-center">Outstanding amount</td>             
                    </tr> 
                    <tr *ngFor="let item of otherLoan; let i = index">
                        <td class="text-center">{{i+1}}</td> 
                        <td class="text-start">{{item?.description}}</td> 
                        <td class="text-start">{{item?.type}}</td> 
                        <td class="text-start pr-3">{{item?.otherInfo}}</td> 
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>          
                    </tr>                                       
                </tbody>
            </table>
        </div>
    </div>
</div>
